import { PLATFORM_TIME_OFF } from '@ApplicationWide/permissions/constants';
import {
  APPROVAL_SETTINGS,
  isCompanySettingsEnabled,
  SURVEYS_SETTINGS,
} from '@ApplicationWide/permissions/companySettings';
import { isAdminOrSuperAdmin } from '@ApplicationWide/permissions/userTypes';
import { FEATURE_FLAG_ABSENCE_MANAGEMENT, FEATURE_FLAG_ABSENCE_MANAGEMENT_ADMIN } from '@ApplicationWide/feature-flags';

export const PAYWALL_TIME_OFF = 'timeOffPaywall';
export const PAYWALL_ORG_CHART = 'orgChartPaywall';

//Stub for future functionality recently implemented in current sapling
export const payWallChecker = (user, company, area) => {
  if (isAdminOrSuperAdmin(user)) {
    if (area === PAYWALL_TIME_OFF) {
      const isAbsenceManagementEnabled =
        company?.baseDetails[FEATURE_FLAG_ABSENCE_MANAGEMENT] ||
        company?.baseDetails[FEATURE_FLAG_ABSENCE_MANAGEMENT_ADMIN];
      return !isAbsenceManagementEnabled;
    }
  }
};

export const canViewTimeOffPaywall = (loggedInUser, company) => {
  return (
    payWallChecker(loggedInUser, company, PAYWALL_TIME_OFF) && !isCompanySettingsEnabled(PLATFORM_TIME_OFF, company)
  );
};

export const canViewSurveyPaywall = (user, company) => {
  return isAdminOrSuperAdmin(user) && !isCompanySettingsEnabled(SURVEYS_SETTINGS, company);
};

export const canViewTrackAndApprovePaywall = (user, company) => {
  return isAdminOrSuperAdmin(user) && !isCompanySettingsEnabled(APPROVAL_SETTINGS, company);
};
